/**
 * @file inviteLink.js
 * @location src/utils/inviteLink.js
 * @role 초대 「링크」 — 코드를 URL 에 실어 공유, 링크로 들어온 팀원에게 자동 프리필.
 *  검증·정규화는 inviteCode.js 재사용. 세션 보관은 OAuth 리다이렉트 가로지르기용 일시값(합류 후 clear).
 */
import { normalizeInviteCode, isValidInviteCode } from './inviteCode.js';

const KEY = 'onjeom_invite';

/** 공유용 초대 링크. */
export function buildInviteUrl(code, origin) {
  const base = origin ?? (typeof location !== 'undefined' ? location.origin : '');
  return `${base}/?invite=${code}`;
}

/** URL search 에서 유효 초대 코드만 추출(없으면 null). */
export function parseInviteParam(search) {
  try {
    const raw = new URLSearchParams(search).get('invite');
    if (!raw) return null;
    const code = normalizeInviteCode(raw);
    return isValidInviteCode(code) ? code : null;
  } catch {
    return null;
  }
}

export function stashInvite(code) {
  try { sessionStorage.setItem(KEY, code); } catch { /* storage 불가 — 무음 */ }
}
export function peekInvite() {
  try { return sessionStorage.getItem(KEY); } catch { return null; }
}
export function clearInvite() {
  try { sessionStorage.removeItem(KEY); } catch { /* 무음 */ }
}
